export default "__VITE_ASSET__ylWShYAJ__"